import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import * as Const from "@utils/Const";
import { useAsync } from "react-async";
import { PromiseHttp } from "@utils/api/HttpUtil";
import { pages } from "@recoil/Store";
import { useRecoilValue } from "recoil";
import Pagenation from "@components/common/Pagenation";
import dayjs from "dayjs";
export default function ProductList(props) {
    let token = localStorage.getItem(Const.TOKEN);
    let lagn = localStorage.getItem(Const.LANG_TYPEA);
    let pageInfo = useRecoilValue(pages);
    const [page, setPage] = useState(pageInfo);
    function handlePage(pages) {
        setPage(Object.assign(Object.assign({}, page), { pageNum: pages - 1 }));
    }
    const { item, setItem } = props;
    const [list, setList] = useState([]);
    let appPath = `?lang=${lagn}`;
    appPath = appPath + `&page=${page.pageNum}&size=${page.size}`;
    if (item.depth2.url !== Const.URL_PRODUCTS) {
        appPath = appPath + `&itemClass=${item.depth2.menuName}`;
    }
    // API
    const { data: data } = useAsync({
        promiseFn: PromiseHttp,
        httpMethod: Const.API_GET,
        appPath: `/admin/item/page${appPath}`,
        appQuery: {},
        userToken: token,
        watch: appPath,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == Const.API_200) {
                setList(data.body);
            }
        }
    }, [data]);
    const handleView = (e, type, view) => {
        if (Const.TYPE_P == type && e.target.nodeName == "BUTTON") {
            setItem(Object.assign(Object.assign({}, item), { type: type, id: view.itemId }));
        }
        else if (type === Const.TYPE_C) {
            setItem(Object.assign(Object.assign({}, item), { type: type }));
        }
        else {
            setItem(Object.assign(Object.assign({}, item), { type: type, id: view.itemId }));
        }
    };
    return (_jsx(_Fragment, { children: _jsxs("section", Object.assign({ className: "board-main" }, { children: [_jsxs("div", Object.assign({ className: "board-header" }, { children: [_jsx("h4", { children: item.depth2.menuName }), _jsx("button", Object.assign({ className: "new-btn", onClick: (e) => handleView(e, Const.TYPE_C, null) }, { children: "\uC2E0\uADDC" }))] })), _jsxs("table", Object.assign({ className: "product-table" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", {}), _jsx("th", { children: "\uC81C\uD488 \uBD84\uB958" }), _jsx("th", { children: "\uC81C\uD488\uBA85" }), _jsx("th", { children: "\uC81C\uD488\uCF54\uB4DC" }), _jsx("th", { children: "\uB178\uCD9C\uC5EC\uBD80" }), _jsx("th", { children: "\uB4F1\uB85D(\uC218\uC815\uC77C)" }), _jsx("th", { children: "\uC218\uC815" })] }) }), _jsx("tbody", { children: list && list.map((val, idx) => (_jsxs("tr", { children: [_jsx("td", Object.assign({ onClick: (e) => handleView(e, Const.TYPE_V, val) }, { children: idx + 1 })), _jsx("td", Object.assign({ onClick: (e) => handleView(e, Const.TYPE_V, val) }, { children: val.itemClass })), _jsx("td", Object.assign({ onClick: (e) => handleView(e, Const.TYPE_V, val) }, { children: val.title })), _jsx("td", Object.assign({ onClick: (e) => handleView(e, Const.TYPE_V, val) }, { children: val.subTitle })), _jsx("td", Object.assign({ onClick: (e) => handleView(e, Const.TYPE_V, val) }, { children: val.isActive ? "O" : "X" })), _jsx("td", Object.assign({ onClick: (e) => handleView(e, Const.TYPE_V, val) }, { children: val.createdAt ? dayjs(val.createdAt).format("YYYY/MM/DD") : "-" })), _jsx("td", Object.assign({ onClick: (e) => handleView(e, Const.TYPE_P, val) }, { children: _jsx("button", Object.assign({ className: "new-btn" }, { children: "\uC218\uC815" })) }))] }, val.itemId))) })] })), _jsx(Pagenation, { page: page, handlePage: handlePage }), _jsx("div", { className: "footer-box" })] })) }));
}
